import React from 'react';
import { Table } from 'semantic-ui-react';
import {
  columnDescription,
  columnLink,
  columnName,
  columnTarget,
  fieldLengths,
  globalFieldLengths,
  hasColumn,
} from '@/constants/fields';
import VocabularyLinkName from '../containers/VocabularyLinkName';
import VocabularyLinkUrl from '../containers/VocabularyLinkUrl';
import VocabularyLinkTarget from '../containers/VocabularyLinkTarget';
import VocabularyLinkDeleteTableCell from '../containers/VocabularyLinkDeleteTableCell';
import VocabularyLinkDescription from '../containers/VocabularyLinkDescription';

const VocabularyLinkRow = ({
  linkUUID,
  entity = 'link',
  columns = [columnName, columnLink, columnTarget],
}) => (
  <Table.Row>
    {hasColumn(columns, columnName) && (
      <VocabularyLinkName
        linkUUID={linkUUID}
        maxLength={entity === 'link' ? globalFieldLengths.name : fieldLengths.micro}
      />
    )}
    {hasColumn(columns, columnLink) && <VocabularyLinkUrl linkUUID={linkUUID} />}
    {hasColumn(columns, columnTarget) && <VocabularyLinkTarget linkUUID={linkUUID} />}
    {hasColumn(columns, columnDescription) && <VocabularyLinkDescription linkUUID={linkUUID} />}
    <VocabularyLinkDeleteTableCell entity={entity} linkUUID={linkUUID} />
  </Table.Row>
);

export default VocabularyLinkRow;
